module.exports = __webpack_public_path__ + "bottomText-green-bg.png?639e5e493cbfa33e27e21bd99bb87bb7";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/bottomText-green-bg.png
// module id = 4
// module chunks = 0